import { takeEvery } from 'redux-saga/effects';

import * as signUpActions from 'store/modules/auth/signUp';
import { verifyReCaptchaV3 } from './utils';

export default function* listenVerifyReCaptchaV3() {
  yield takeEvery(signUpActions.verifyReCaptchaV3.toString(), verifyReCaptchaV3);
}
